import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { TextBold } from 'UiKit/typography';
import FilterDateRangePicker from 'UiKit/filter-date-range-picker';
import ListReportPresence from 'View/host-presence-content/components/list-report-presence';
import OverviewPresence from 'View/host-presence-content/section/overview-presence';
import { useHostPresenceContentState } from 'View/host-presence-content/state';

import styles from './styles.module.css';

const ReportPresence = () => {
  const { t } = useTranslation('host-presence');
  const { filterState, updateFilterState } = useHostPresenceContentState();

  const onChangeDateRange = ({ startDate, endDate }) => {
    updateFilterState({ startDate, endDate, page: 1 });
  };

  return (
    <Box className={styles['report-presence__container']}>
      <OverviewPresence />
      <Box className={styles['report-presence__content']}>
        <TextBold>{t('page.report_title')}</TextBold>
        <FilterDateRangePicker
          startDate={filterState?.startDate}
          endDate={filterState?.endDate}
          onChange={onChangeDateRange}
          icon="calendar"
          placement="right"
          variant="outlined"
        />
        <ListReportPresence />
      </Box>
    </Box>
  );
};

export default ReportPresence;
